import { Component, HostBinding, HostListener, Input, OnDestroy } from '@angular/core';
import { WtfAnimations } from '../../../../utils/others/core/animations';
import { WtfConfigService } from '../../../../services/core/config.service';
import { Subscription } from 'rxjs';

@Component({
    selector   : 'wtf-nav-horizontal-collapse',
    templateUrl: './nav-horizontal-collapse.component.html',
    styleUrls  : ['./nav-horizontal-collapse.component.scss'],
    animations : WtfAnimations
})
export class WtfNavHorizontalCollapseComponent implements OnDestroy
{
    onSettingsChanged: Subscription;
    wtfSettings: any;
    isOpen = false;

    @HostBinding('class') classes = 'nav-item nav-collapse';
    @Input() item: any;

    @HostListener('mouseenter')
    open()
    {
        this.isOpen = true;
    }

    @HostListener('mouseleave')
    close()
    {
        this.isOpen = false;
    }

    constructor(
        private wtfConfig: WtfConfigService
    )
    {
        this.onSettingsChanged =
            this.wtfConfig.onSettingsChanged
                .subscribe(
                    (newSettings) => {
                        this.wtfSettings = newSettings;
                    }
                );
    }

    ngOnDestroy()
    {
        this.onSettingsChanged.unsubscribe();
    }
}
